import FormFirstStep from "../steps/FormFirstStep";
import FormSecondStep from "../steps/FormSecondStep";
import FormThirdStep from "../steps/FormThirdStep";
import FirstStepSummary from "../summary/FirstStepSummary";
import SecondStepSummary from "../summary/SecondStepSummary";

export const getSteps = (component: any) => {
  return [
    {
      label: "Shipping information",
      Component: FormFirstStep,
      Summary: FirstStepSummary,
    },
    {
      label: "Shipping method",
      Component: FormSecondStep,
      Summary: SecondStepSummary,
    },
    {label: "Payment", Component: component ||  FormThirdStep},
  ];
};